import { create } from 'zustand';

type TopicExportModalStore = {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
};

/**
 * Simple Zustand store for the Topic export modal actions.
 * Used this to open and close the Topic export modal from anywhere in the app.
 */
export const useTopicExportModalStore = create<TopicExportModalStore>((set) => ({
  isOpen: false,
  openModal: () => set({ isOpen: true }),
  closeModal: () => set({ isOpen: false })
}));
